export default __webpack_public_path__ + "static/media/Desenvolvimento-Medida.08803a87.png";